import React from 'react';
import { Card, Form, InputNumber, Button, Select, ColorPicker } from 'antd';
import { useTheme } from '../contexts/ThemeContext';

const fonts = [
  'Montserrat',
  'Arial',
  'Verdana',
  'Helvetica',
  'Times New Roman',
  'Trebuchet MS',
  'Georgia',
  'Garamond',
  'Courier New',
  'Brush Script MT'
];

const ThemeEditor: React.FC = () => {
  const { theme, updateTheme } = useTheme();
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {

    values.colorPrimary = values.colorPrimary.toHexString();
    values.colorSecondary = values.colorSecondary.toHexString();
    updateTheme(values);

  };

  return (
    <Card className='m-2 w-100'>
      <Form
        form={form}
        initialValues={theme}
        onFinish={handleSubmit}

        labelCol={{ span: 12 }}
        wrapperCol={{ span: 20 }}
        labelAlign='left'
      >

        <Form.Item label="Primary Color" name="colorPrimary" className='my-3'>
          
          <ColorPicker showText={true} defaultFormat='hex' format='hex'></ColorPicker>
        </Form.Item>

        <Form.Item label="Secondary Color" name="colorSecondary" className='my-3'>
          <ColorPicker showText={true} defaultFormat='hex' format='hex'></ColorPicker>
        </Form.Item>

        <Form.Item label="Font" name="font" className='my-3'>
          <Select>
            {fonts.map(font => (
              <Select.Option key={font} value={font}>
                {font}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="inputHeight" label="Input and Buttons height" className='my-3'>
          <InputNumber min={20} max={100} />
        </Form.Item>
        <Form.Item name="borderRadius" label="Border radius" className='my-3'>
          <InputNumber min={0} max={24} style={{ width: '100%' }} />
        </Form.Item>

        <div className='mt-2 text-right w-100'>
          <Button type="primary" htmlType="submit" >
            Save
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default ThemeEditor; 